import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {
  transform(currencyCode: string): string {
    switch (currencyCode) {
      case 'USD':
      case 'ARS':
      case 'CLP':
        return '$'
      case 'EURO':
        return '€';
      case 'PEN':
        return'S/';
      case 'CLF':
        return 'UF';
      default:
        return currencyCode; 
    }
  }
}